import { render, staticRenderFns } from "./bannerStatic.vue?vue&type=template&id=65d19d81&scoped=true"
import script from "./bannerStatic.vue?vue&type=script&lang=js"
export * from "./bannerStatic.vue?vue&type=script&lang=js"
import style0 from "./bannerStatic.vue?vue&type=style&index=0&id=65d19d81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d19d81",
  null
  
)

export default component.exports